import {Component, OnDestroy, OnInit} from '@angular/core';
import {ParametriaService} from '../../../../_services/parametria.service';
import {takeUntil} from 'rxjs';
import {Subject} from 'rxjs/internal/Subject';
import {convertirFormatoFechaHora} from '../../../../utils/utilidades';
import {SimuladorConfiguracionService} from '../../../../_services/simulador-configuracion.service';

@Component({
  selector: 'app-sincronizacion-offline',
  templateUrl: './widget-sincronizacion-offline.component.html',
  styleUrl: './widget-sincronizacion-offline.component.css'
})
export class WidgetSincronizacionOfflineComponent implements OnInit, OnDestroy {

  // Variables para renderizado
  cargando: boolean = true;
  loading: boolean = false;

  // Variables para mostrar informacion
  fechaUltimaSincronizacion: string = null;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private principalService: SimuladorConfiguracionService,
              private parametriaService: ParametriaService) {}

  ngOnInit() {
    this.cargaInicial();
  }

  cargaInicial() {
    this.cargando = true;
    this.parametriaService.estadoShivan().pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.fechaUltimaSincronizacion = convertirFormatoFechaHora(response?.fechaSincronizacionSimuladorOffline, true) ?? null;
          this.cargando = false;
        },
        error: (error) => {
          this.fechaUltimaSincronizacion = null;
          console.log('Se ha generado un error al obtener la fecha de ultima sincronizacion ', error);
          this.cargando = false;
        }
      });
  }

  actualizarInformacion() {
    this.loading = true;
    this.principalService.actualizarInformacion().pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          const mensaje = response?.mensaje ?? null;
          if (response?.estado) {
            this.fechaUltimaSincronizacion = !!mensaje ? convertirFormatoFechaHora(mensaje, true) : null;
          }

          this.loading = false;
        },
        error: (error) => {
          this.fechaUltimaSincronizacion = this.fechaUltimaSincronizacion ?? null;
          console.log('Se ha generado un error al actualizar la informacion ', error);
          this.loading = false;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
